import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ErrorDialogComponent } from "./error-dialog.component";

import { takeUntil } from "rxjs/operators";
import { DialogType } from "../../models/dialog.enum";
import { SimpleModalService } from "../sepidzmodal/simple-modal.service";
@Injectable()
export class ErrorDialogService implements OnDestroy {
  ngUnsubscribe = new Subject<void>();
  protected onClose$: Subject<any> = new Subject();
  get onClose(): Observable<any> {
    return this.onClose$.asObservable();
  }
  constructor(private dialogService: SimpleModalService) {}
  openDialog(title: string, errorMessage: string, _type: DialogType) {
    setTimeout(
      () =>
        this.dialogService
          .open(
            ErrorDialogComponent,
            {
              title: title,
              errorMessage: errorMessage,
              dialogType: _type,
            },
            {
              autoFocus: true,
              closeOnClickOutside: false,
            }
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((flag) => {
            this.onClose$.next(flag);
          }),
      200
    );
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    if (this.onClose$) {
      this.onClose$.next(null);
      this.onClose$.complete();
    }
  }
}
